import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import FadeIn from "react-lazyload-fadein";
import { Parallax } from 'react-scroll-parallax';
import  { Redirect } from 'react-router-dom';
import AccountMenu from './AccountMenu';
import AccountWelcome from './AccountWelcome';
import AccountSettings from './AccountSettings';
import AccountQuotes from './AccountQuotes';
import Foot from './Foot';

const Account = ({ context }) => {

    const posts = () => context.posts;
    const post = posts()[0];
        
    if (post) {
    
	    const ctxUser = () => context.user;
		const user = ctxUser();
		    
	    const ctxPageLoaded = () => context.pageLoaded;
	    const pageLoaded = ctxPageLoaded();
	    
	    const ctxRestType = () => context.restType;
	    const restType = ctxRestType();
	    
	    let pageClass = 'c-page-wrapper state-not-loaded';
	    if (pageLoaded == true) {
		    pageClass = 'c-page-wrapper state-loaded';
	    }
	    
	    function toggleLogin(evt) {
			evt.preventDefault();
			context.toggleLogin();
		}
		
		if (user.id === false || user.id === 'false' || user.id === null) {
			
			return <Redirect to='/'  />
			
		} else {

	    	return (
		    	<div className={pageClass}>
		    	
		    		{post.header_srcset &&
			    		<div className="c-header-image">
			    			<Parallax className="c-header-image__background" y={[-10, 10]} tagOuter="div">
			    				<FadeIn duration={250}>
									{onload => (
										<img
											src={post.header_src} 
											srcSet={post.header_srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							</Parallax>
			    		</div>
		    		}
		    		
		    		<AccountMenu></AccountMenu>
		    		
		    		{restType == 'account' &&
			    		<AccountWelcome></AccountWelcome>
					}
					
					{restType == 'details' &&
						<AccountSettings></AccountSettings>
					}
					
					{restType == 'requests' &&
						<AccountQuotes></AccountQuotes>
					}
						
					<Foot></Foot>
					
				</div>
	    	)
	
		}
		
	} else {
		return null;
	}
};
export default WithConsumer(Account);